/* eslint-disable @typescript-eslint/no-require-imports */
export function generateMD5Hash(input) {
    const crypto = require('crypto-js');
    return crypto.MD5(input).toString();
}
